export const getCartInfoItemQty = (cartItem, categoryId, cartInfo) => {
    const isMatch = (i) => i.itemId === cartItem.productDetails?.find((pd) => pd.id.toString() === i.itemId)?.id.toString();
    //Catalog is -1
    if (categoryId === '-1') {
      // Sum quantities across ALL matching cart categories
      return (cartInfo?.cartItems ?? [])
        .flatMap((cartCat) => cartCat.items ?? [])
        .filter(isMatch)
        .reduce((sum, i) => sum + (i.quantity ?? 0), 0);
    }
    // normal category behavior
    const categoryCartInfo = cartInfo?.cartItems?.find((c2) => c2.categoryId.toString() === categoryId);
    return (categoryCartInfo?.items ?? [])
      .filter(isMatch)
      .reduce((sum, i) => sum + (i.quantity ?? 0), 0);
  };